<script>
	import PageFooter from "./components/PageFooter.svelte";
	import PageHeader from "./components/PageHeader.svelte";
	import Router from "./routes/Router.svelte";

	import { initialiseAnalytics } from "./analytics";
	import { projectSettings } from "./config";

	export let url = "";

	const basepath = window.basePath || "/";

	const disableSubmitOnEnter = (e) => {
		if (e.which != "13") return;

		if (e.target && e.target.type && e.target.type != "textarea") {
			e.preventDefault();
		}
	};

	initialiseAnalytics();
</script>

<svelte:head>
	<!-- Google Tag Manager -->
	<script>
		(function (w, d, s, l, i) {
			w[l] = w[l] || [];
			w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != "dataLayer" ? "&l=" + l : "";
			j.async = true;
			j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, "script", "dataLayer", "GTM-TW92CF2W");
	</script>
	<!-- End Google Tag Manager -->
</svelte:head>

<div
	class="page-container"
	on:keypress={(e) => disableSubmitOnEnter(e)}
	style="--highlight-color: #e46937; --error-color: #D83737;"
>
	<PageHeader></PageHeader>

	<form novalidate autocomplete="off">
		<Router {url} {basepath}></Router>
	</form>
</div>

<span class="build-id-tag">Class Action - NUIX Shareholder_ee85c1a7c9d52333fd6c694a08c930cdc072a7bc</span>

<PageFooter></PageFooter>

<style>
	.build-id-tag {
		color: #252525;
		position: absolute;
		top: 10px;
		right: 10px;
		font-size: 8px;
	}

	.page-container {
		min-height: calc(100vh - 155px);
	}
</style>
